// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38Tjv","notes":"Notes_notes__3inY1"};